import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "form-content" }
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = { class: "flex flex-row sm-flex-col md-flex-col gap-4" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "options" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "item empty" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "options" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "item empty" }

import { computed, ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import { bsonId } from "@/common/utils/common";

import {
  svgIcon,
  baseInput,
  baseTextarea,
  baseSelect,
} from "@/common/components";

import { QuestionPayloadType, OptionType } from "@/common/types/question";


export default /*@__PURE__*/_defineComponent({
  __name: 'question',
  props: {
    data: {},
    title: {},
    width: { default: "100%" },
    remove: {}
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v1ab8e74a": (_ctx.width)
}))

const { t, tm } = useI18n();

const emit = __emit;

const props = __props;

const defaultData = {
  description: "",
  placeholder: null,
  metadata: null,
  name: "",
  type: "input",
  required: false,
};

const payload = ref<QuestionPayloadType>({ ...defaultData });
const options = ref<OptionType[]>([]);
const fileType = ref("");

const types = computed(
  () => tm("enums.question_type") as Record<string, string>,
);
const typesOptions = computed(() =>
  Object.entries(types.value)
    .map(([key, label]) => ({
      option: label,
      value: key,
    }))
    .filter((item) => !props.remove?.includes(item.value)),
);

const fileTypes = computed(
  () => tm("question.file_types") as Record<string, string>,
);
const fileTypesOptions = computed(() =>
  Object.entries(fileTypes.value).map(([key, label]) => ({
    option: label,
    value: key,
  })),
);

const requireOptions = computed(() => [
  {
    option: t("common.labels.yes"),
    value: true,
  },
  {
    option: t("common.labels.not"),
    value: false,
  },
]);

function update() {
  emit("update-data", payload.value);
}

function addOption() {
  options.value.push({
    id: bsonId(),
    option: "",
    value: null,
  });
  updateOptions();
}

function delOption(index: number) {
  options.value.splice(index, 1);
  updateOptions();
}

function updateOptions() {
  updateMetadata("options", options.value);
}

function updateMetadata(key: string, value: any) {
  payload.value.metadata = {
    ...payload.value.metadata,
    [key]: value,
  };
  update();
}

function updateFile(key: string) {
  const extensions = {
    document: ["doc", "docx", "xml", "pdf", "csv"],
    image: ["jpeg", "jpg"],
  };
  updateMetadata("file", {
    type: key,
    extension: extensions[key as never],
  });
}

function changeType(value: string) {
  payload.value.metadata = null;

  if (value === "file") {
    updateFile("document");
  } else {
    update();
  }
}

function fetchMetadata(metadata: any) {
  if (!metadata) return;

  if (typeof metadata === "string") {
    metadata = JSON.parse(metadata);
  }

  if (metadata?.options) options.value = metadata.options;

  if (metadata?.file) fileType.value = metadata.file.type;
}

watchEffect(() => {
  if (props.data) {
    payload.value = { ...props.data };

    if (props.data.metadata) {
      fetchMetadata(props.data.metadata);
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_tempate = _resolveComponent("tempate")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("form", null, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(baseSelect), {
          modelValue: payload.value.type,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.type) = $event)),
          value: payload.value.type,
          options: typesOptions.value,
          "is-empty": false,
          onChange: changeType
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("common.labels.type")), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "value", "options"]),
        _createVNode(_unref(baseSelect), {
          modelValue: payload.value.required,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((payload.value.required) = $event)),
          value: payload.value.required,
          options: requireOptions.value,
          "is-empty": false,
          onChange: _cache[2] || (_cache[2] = ($event: any) => (update()))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("common.labels.required")), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "value", "options"])
      ]),
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.name,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((payload.value.name) = $event)),
        value: payload.value.name,
        placeholder: _unref(t)('common.placeholders.name'),
        onInput: _cache[4] || (_cache[4] = ($event: any) => (update()))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"]),
      (payload.value.type === 'INPUT' || payload.value.type === 'TEXTAREA')
        ? (_openBlock(), _createBlock(_unref(baseInput), {
            key: 0,
            modelValue: payload.value.placeholder,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((payload.value.placeholder) = $event)),
            value: payload.value.placeholder,
            onInput: _cache[6] || (_cache[6] = ($event: any) => (update()))
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.labels.example")), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "value"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(baseTextarea), {
        modelValue: payload.value.description,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((payload.value.description) = $event)),
        value: payload.value.description,
        placeholder: _unref(t)('common.placeholders.describe'),
        onInput: _cache[8] || (_cache[8] = ($event: any) => (update()))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.description")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"]),
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "separate" }, null, -1)),
      (payload.value.type === 'FILE')
        ? (_openBlock(), _createBlock(_unref(baseSelect), {
            key: 1,
            modelValue: fileType.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((fileType).value = $event)),
            value: fileType.value,
            options: fileTypesOptions.value,
            onChange: updateFile
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.labels.type")), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "value", "options"]))
        : _createCommentVNode("", true),
      (payload.value.type === 'RADIO' || payload.value.type === 'SELECT')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_4, [
              _createTextVNode(_toDisplayString(_unref(t)("common.labels.options")) + " ", 1),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary btn-sm",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (addOption()))
              }, [
                _createVNode(_unref(svgIcon), {
                  icon: "add",
                  size: "1rem"
                }),
                _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.option").toUpperCase()), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "item"
                }, [
                  _createVNode(_unref(baseInput), {
                    modelValue: item.option,
                    "onUpdate:modelValue": ($event: any) => ((item.option) = $event),
                    value: item.option,
                    placeholder: _unref(t)('common.labels.name'),
                    onInput: _cache[11] || (_cache[11] = ($event: any) => (updateOptions()))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "value", "placeholder"]),
                  _createVNode(_unref(baseInput), {
                    modelValue: item.value,
                    "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                    value: item.value,
                    placeholder: _unref(t)('common.labels.value'),
                    onInput: _cache[12] || (_cache[12] = ($event: any) => (updateOptions()))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "value", "placeholder"]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm",
                    onClick: ($event: any) => (delOption(index))
                  }, [
                    _createVNode(_unref(svgIcon), {
                      icon: "trash",
                      size: "1rem"
                    })
                  ], 8, _hoisted_6)
                ]))
              }), 128)),
              (options.value.length === 0)
                ? (_openBlock(), _createBlock(_component_tempate, { key: 0 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)("common.texts.no_results")), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ], 64))
        : _createCommentVNode("", true),
      (payload.value.type === 'CHECKBOX')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("div", _hoisted_8, [
              _createTextVNode(_toDisplayString(_unref(t)("common.labels.options")) + " ", 1),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary btn-sm",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (addOption()))
              }, [
                _createVNode(_unref(svgIcon), {
                  icon: "add",
                  size: "1rem"
                }),
                _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.option").toUpperCase()), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "item"
                }, [
                  _createVNode(_unref(baseInput), {
                    modelValue: item.option,
                    "onUpdate:modelValue": ($event: any) => ((item.option) = $event),
                    value: item.option,
                    placeholder: _unref(t)('common.labels.name'),
                    onInput: _cache[14] || (_cache[14] = ($event: any) => (updateOptions()))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "value", "placeholder"]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm",
                    onClick: ($event: any) => (delOption(index))
                  }, [
                    _createVNode(_unref(svgIcon), {
                      icon: "trash",
                      size: "1rem"
                    })
                  ], 8, _hoisted_10)
                ]))
              }), 128)),
              (options.value.length === 0)
                ? (_openBlock(), _createBlock(_component_tempate, { key: 0 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)("common.texts.no_results")), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})